import { render } from "./Createform.vue?vue&type=template&id=dc4fbd0c"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Createform.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc4fbd0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc4fbd0c', __exports__)) {
    api.reload('dc4fbd0c', __exports__)
  }
  
  module.hot.accept("./Createform.vue?vue&type=template&id=dc4fbd0c", () => {
    api.rerender('dc4fbd0c', render)
  })

}


export default __exports__